import ArmsRum from "@arms/rum-browser";
ArmsRum.init({
  pid: "gvdo6clmvo@c911f03852f3dda",
  endpoint: "https://gvdo6clmvo-default-cn.rum.aliyuncs.com",
  env: "local",
  version: "1.0.0",
  evaluateApi: async (options, response, error) => {
    let messageStr = "";
    let success = true;
    // 当前为使用fetch请求的情况
    try {
      const _data = JSON.parse(response);
      const { code, message } = _data;
      success = _data.success;
      messageStr = `${code}/${message}`;
    } catch (e) {
      console.log(e);
    }
    // 返回的字段会覆盖默认内容，不返回的字段会依然使用SDK自定生成内容
    return {
      message: messageStr,
      success: error || !success ? 0 : 1,
    };
  },
});
